import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Requests a short-lived signed download URL for a patient imaging asset via
 * the downloadHandler Cloud Function, replacing the direct Firebase Storage
 * SDK download path. Authorization is enforced server-side from the caller's
 * verified identity - this function never supplies a uid, bucket, or filename.
 *
 * @param {{asset: 'mri_volume'|'segmentation'|'model', patientId: string}} params
 * @returns {Promise<string|null>} the signed URL, or null if the optional
 *   model asset isn't ready yet. Any other rejection (including
 *   permission-denied and unauthenticated) propagates as an error.
 */
export function getSignedDownloadUrl({ asset, patientId }) {
  const app = getApp();
  const region = import.meta.env.VITE_LOCATION || 'europe-west9';
  const functions = getFunctions(app, region);
  const downloadHandler = httpsCallable(functions, 'downloadHandler');

  return downloadHandler({ asset, patient_id: patientId })
    .then((result) => result.data.url)
    .catch((err) => {
      if (asset === 'model' && err?.code === 'functions/not-found') {
        return null;
      }
      throw err;
    });
}
